// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Hb5vE","actions":"styles_actions__bC8BE","actions_btn":"styles_actions_btn__5xsCL"};